import { HelmetDexteel } from "@dexteel/mesf-core";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { TableCarrierAssembly } from "./components/TableCarrierAssembly";
import { Carrier } from "./models/Carrier";
import { getCarriers } from "./repositories/CarrierAssemblyRepository";

type useCarrierAssemblyProps = {
	partId?: number;
};

export const useCarriersAssembly = ({ partId }: useCarrierAssemblyProps) => {
	return useQuery<Carrier[], Error>({
		queryKey: ["carriersAssembly", partId],
		meta: { realtime: ["M2.GetCarriers"] },
		queryFn: ({ signal }) => getCarriers({ partId }, signal),
	});
};

export const CarrierPage = () => {
	const { partId } = useParams();

	return (
		<>
			<HelmetDexteel title="Carrier Status" />
			<TableCarrierAssembly partId={partId} />
		</>
	);
};
